function closePopups() {
	if ($('.js-popup.is-active').length) {
		const popupId = $('.js-popup.is-active').data('popup-id');

		if (popupId.indexOf('video') !== -1) {
			if ($(`.js-popup[data-popup-id=${popupId}] video`).length) {
				const video = $(`.js-popup[data-popup-id=${popupId}] video`);
				video.get(0).currentTime = 0;
				video.get(0).pause();
			}
		}
	}

	$('.js-popup').removeClass('is-active');
	$('body').removeClass('overflow-hidden');
}
